/**
 * Extras de pago de la ficha de producto.
 *
 * Al enviar el formulario de compra, ademas del producto principal se anaden
 * las variantes marcadas con data-miss-extra. Todo va en una sola peticion
 * multipart a /cart/add.js con la notacion items[i][...], que admite tambien
 * archivos (el diseno propio de la medalla).
 *
 * Principal y extras se vinculan con un testigo unico por anadido: la linea
 * principal lo lleva en properties[_grupo] y cada extra en properties[_extra_de].
 * No se usa el id de variante porque el mismo producto puede anadirse dos veces
 * -una con regalo y otra sin el- y ambas lineas compartirian variante, dejando
 * ambiguo a que linea pertenece cada extra.
 *
 * Los campos que despliega la casilla de un extra (el mensaje del packaging,
 * el archivo del diseno propio) viajan en la linea del extra, no en la
 * principal: asi, quitar el extra en el carrito se lleva sus datos. Con el
 * mensaje en la cinta, #MH1381 llego con mensaje y sin el packaging que lo
 * paga, porque la clienta borro esa linea en el carrito.
 */
(function () {
  'use strict';

  function nuevoTestigo() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    // Reserva para navegadores sin randomUUID (Safari anterior a 15.4).
    return 'g-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  // --- Despliegue de campos asociados a una casilla -----------------------

  /**
   * Muestra u oculta los campos de una casilla y los habilita a la par.
   *
   * Ocultar no basta: FormData recoge los campos ocultos, asi que un mensaje de
   * regalo escrito y luego desmarcado llegaba al pedido sin el packaging.
   * FormData si ignora los deshabilitados.
   */
  function aplicaToggle(origen) {
    var destino = document.querySelector(origen.dataset.missToggle);
    if (!destino) return;

    destino.hidden = !origen.checked;
    Array.prototype.forEach.call(
      destino.querySelectorAll('input, textarea, select'),
      function (campo) { campo.disabled = !origen.checked; }
    );
  }

  document.addEventListener('change', function (evt) {
    var origen = evt.target.closest('[data-miss-toggle]');
    if (origen) aplicaToggle(origen);
  });

  // El navegador puede devolver la casilla marcada al volver atras (bfcache o
  // autocompletado de formularios); los campos deben seguirla.
  function sincronizaToggles() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-miss-toggle]'), aplicaToggle);
  }

  document.addEventListener('DOMContentLoaded', sincronizaToggles);
  window.addEventListener('pageshow', sincronizaToggles);

  // --- Contador de caracteres de los campos de grabado --------------------

  document.addEventListener('input', function (evt) {
    var campo = evt.target.closest('[data-miss-contador]');
    if (!campo) return;

    var contador = campo.parentElement.querySelector('.miss-medalla__contador');
    if (!contador) return;

    var restantes = campo.maxLength - campo.value.length;
    contador.textContent = restantes === 1
      ? '1 caracter restante'
      : restantes + ' caracteres restantes';
  });

  // --- Archivo del diseno propio ------------------------------------------

  var TIPOS_DISENO = /\.(pdf|jpe?g|png)$/i;

  /**
   * Revisa el archivo en cuanto se elige. Shopify lo sube al anadir al
   * carrito, asi que este es el momento de avisar de un tipo o un tamano que
   * no sirven, antes de que la clienta espere una subida que va a fallar.
   *
   * Se registra antes que revisaObligatorios: si el archivo se descarta, la
   * validacion ya ve el campo vacio.
   */
  document.addEventListener('change', function (evt) {
    var campo = evt.target.closest('[data-miss-archivo]');
    if (!campo) return;

    var archivo = campo.files && campo.files[0];
    var maxMb   = Number(campo.dataset.missMaxMb || 10);
    var error   = '';

    if (archivo && !TIPOS_DISENO.test(archivo.name)) {
      error = 'El diseño tiene que ser un PDF, JPG o PNG.';
    } else if (archivo && archivo.size > maxMb * 1024 * 1024) {
      error = 'El archivo pesa más de ' + maxMb + ' MB.';
    }
    if (error) campo.value = '';

    var aviso = campo.parentElement.querySelector('.miss-medalla__archivo-error');
    if (aviso) {
      aviso.textContent = error;
      aviso.hidden = !error;
    }
  });

  // --- Validacion de campos obligatorios ----------------------------------

  /**
   * Habilita el boton de compra solo cuando todos los campos obligatorios
   * tienen valor. Los radios cuentan como uno: basta con que haya alguno
   * marcado dentro de su grupo de nombre.
   *
   * Si la ficha no declara obligatorios -un zapato, por ejemplo- no se toca
   * el boton, que debe seguir habilitado.
   *
   * Un campo deshabilitado no cuenta: es el de una casilla sin marcar (el
   * archivo del diseno propio solo es obligatorio con la suya marcada).
   */
  function revisaObligatorios() {
    var campos = document.querySelectorAll('[data-miss-obligatorio]');
    if (!campos.length) return;

    var gruposVistos = {};
    var completo = true;

    Array.prototype.forEach.call(campos, function (campo) {
      if (campo.disabled) return;
      if (campo.type === 'radio') {
        if (gruposVistos[campo.name]) return;
        gruposVistos[campo.name] = true;
        if (!document.querySelector('input[name="' + CSS.escape(campo.name) + '"]:checked')) {
          completo = false;
        }
        return;
      }
      if (!campo.value.trim()) completo = false;
    });

    var formId = campos[0].getAttribute('form');
    var form   = formId ? document.getElementById(formId) : null;
    var boton  = form ? form.querySelector('[type="submit"]') : null;
    if (boton) boton.disabled = !completo;
  }

  document.addEventListener('change', revisaObligatorios);
  document.addEventListener('input', revisaObligatorios);
  document.addEventListener('DOMContentLoaded', revisaObligatorios);
  window.addEventListener('pageshow', revisaObligatorios);

  // --- Envio con extras ---------------------------------------------------

  /** Campos properties[...] que despliega la casilla de un extra. */
  function camposDelExtra(casilla) {
    var destino = casilla.dataset.missToggle
      ? document.querySelector(casilla.dataset.missToggle)
      : null;
    return destino
      ? Array.prototype.slice.call(destino.querySelectorAll('[name^="properties["]'))
      : [];
  }

  /** Valor de un campo como lo recogeria FormData, o null si no se envia. */
  function valorDelCampo(campo) {
    if (campo.disabled) return null;
    if (campo.type === 'file') {
      var archivo = campo.files && campo.files[0];
      return archivo && archivo.size ? archivo : null;
    }
    if ((campo.type === 'checkbox' || campo.type === 'radio') && !campo.checked) return null;
    return campo.value || null;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    var extras = Array.prototype.filter.call(
      document.querySelectorAll('[data-miss-extra]'),
      function (c) { return c.checked && c.form === form; }
    );
    if (!extras.length) return;

    // A partir de aqui el envio lo gestionamos nosotros.
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var testigo = nuevoTestigo();
    var datos   = new FormData(form);
    var envio   = new FormData();

    /*
     * Multipart y no JSON: en JSON no cabe el archivo del diseno propio.
     * Shopify lo guarda en su CDN y deja su enlace en la propiedad; los
     * extras viajan en la misma peticion, asi que entran todos o ninguno.
     */
    envio.append('items[0][id]', datos.get('id'));
    envio.append('items[0][quantity]', String(Number(datos.get('quantity') || 1)));
    envio.append('items[0][properties][_grupo]', testigo);

    // Los campos de cualquier extra, marcado o no, quedan fuera de la principal.
    var deExtras = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-miss-extra]'), function (c) {
      if (c.form !== form) return;
      camposDelExtra(c).forEach(function (campo) { deExtras[campo.name] = true; });
    });

    datos.forEach(function (valor, clave) {
      var m = clave.match(/^properties\[(.+)\]$/);
      if (!m || deExtras[clave]) return;
      var vacio = valor instanceof File ? !valor.size : !valor;
      if (!vacio) envio.append('items[0][properties][' + m[1] + ']', valor);
    });

    extras.forEach(function (c, i) {
      var n = i + 1;
      envio.append('items[' + n + '][id]', c.dataset.missExtra);
      envio.append('items[' + n + '][quantity]', '1');
      envio.append('items[' + n + '][properties][_extra_de]', testigo);

      camposDelExtra(c).forEach(function (campo) {
        var valor = valorDelCampo(campo);
        var m = campo.name.match(/^properties\[(.+)\]$/);
        if (valor !== null && m) envio.append('items[' + n + '][properties][' + m[1] + ']', valor);
      });
    });

    var boton = form.querySelector('[type="submit"]');
    if (boton) boton.classList.add('adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: envio
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.json.description || res.json.message || 'Error al anadir al carrito');
        }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        var aviso = form.querySelector('.error-message');
        if (aviso) {
          aviso.textContent = err.message;
          aviso.style.display = 'block';
        } else {
          alert(err.message);
        }
      })
      .finally(function () {
        if (boton) boton.classList.remove('adding');
      });
  }, true); // fase de captura: hay que adelantarse al manejador del theme

  // --- Limpieza de extras huerfanos ---------------------------------------

  /**
   * Elimina los extras cuyo producto principal ya no esta en el carrito.
   *
   * Sin esto, quien borre los zapatos se queda pagando 3,99 por envolver nada,
   * que acaba en reclamacion. Es deliberadamente conservador: si no encuentra
   * huerfanos no toca nada, y cualquier fallo se ignora para no romper la
   * navegacion.
   */
  function limpiaHuerfanos() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        var gruposVivos = {};
        carrito.items.forEach(function (item) {
          var g = item.properties && item.properties._grupo;
          if (g) gruposVivos[g] = true;
        });

        var huerfanos = carrito.items.filter(function (item) {
          var padre = item.properties && item.properties._extra_de;
          return padre && !gruposVivos[padre];
        });

        if (!huerfanos.length) return null;

        var updates = {};
        huerfanos.forEach(function (item) { updates[item.key] = 0; });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          // Solo se recarga en el carrito, que es donde el cambio se ve.
          if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
        });
      })
      .catch(function () { /* no romper la navegacion por esto */ });
  }

  document.addEventListener('DOMContentLoaded', limpiaHuerfanos);

  // El evento lo despacha el theme sobre document al modificar el carrito
  // (assets/theme.js:3810). Se comprobo contra el theme: no existe ningun
  // 'cart:updated', que es el nombre que suele suponerse.
  document.addEventListener('theme:cartchanged', limpiaHuerfanos);
})();
